import type {
  LessonEditableVersionViewFull,
  LessonEditableVersionViewFullNumberedTitled,
  LessonEditableVersionViewInternal,
  LessonVersionViewFull,
  LessonVersionViewFullNumberedTitled,
  LessonVersionViewMinimal,
  LessonVersionWithSequencesViewMinimal,
  LessonVersionWithSequencesViewMinimalNumberedTitled,
  LessonViewFull,
  LessonViewFullNumberedTitled,
  LessonViewInternal,
  LessonViewMinimal,
} from '@didaskill/domain/lessons/types';
import { computeSequenceNumbers } from '@didaskill/domain/lessons/utils';

// TODO map this from the backend so we can remove these mappers.

export const mapVersion = (
  version:
    | LessonVersionViewMinimal
    | LessonVersionWithSequencesViewMinimal
    | LessonEditableVersionViewInternal
    | LessonVersionViewFull
    | LessonEditableVersionViewFull,
):
  | LessonVersionViewMinimal
  | LessonVersionWithSequencesViewMinimalNumberedTitled
  | LessonEditableVersionViewInternal
  | LessonVersionViewFullNumberedTitled
  | LessonEditableVersionViewFullNumberedTitled =>
  'sequences' in version
    ? {
        ...version,
        sequences: computeSequenceNumbers(
          (
            version as
              | LessonVersionWithSequencesViewMinimalNumberedTitled
              | LessonVersionViewFullNumberedTitled
              | LessonEditableVersionViewFullNumberedTitled
          ).sequences,
        ),
      }
    : { ...version };

export const mapLesson = (
  lesson: LessonViewFull | LessonViewMinimal | LessonViewInternal,
): LessonViewFullNumberedTitled | LessonViewMinimal | LessonViewInternal =>
  'versions' in lesson || 'editableVersions' in lesson
    ? {
        ...lesson,
        skills: (lesson as LessonViewFull | LessonViewInternal).skills || [],
        versions: (lesson as LessonViewFull | LessonViewInternal).versions?.map(
          (version: LessonVersionViewFull | LessonVersionViewMinimal) => mapVersion(version),
        ) as LessonVersionViewFullNumberedTitled[] | LessonVersionViewMinimal[],
        editableVersions: (lesson as LessonViewFull | LessonViewInternal).editableVersions?.map(
          (version: LessonEditableVersionViewFull | LessonEditableVersionViewInternal) =>
            mapVersion(version),
        ) as LessonEditableVersionViewFullNumberedTitled[] | LessonEditableVersionViewInternal[],
      }
    : lesson;
